import { useState } from 'react';
import { Mail, Phone, User, MapPin, Users } from 'lucide-react';
import { toast } from 'sonner';

export default function QuoteForm() {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', destination: '', groupSize: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://formspree.io/f/myzqwert', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          _subject: `Novo Orçamento - ${formData.name}`,
          _replyto: formData.email,
        }),
      });
      if (response.ok) {
        toast.success('Orçamento enviado com sucesso!', { description: 'Entraremos em contato em breve.' });
        setFormData({ name: '', phone: '', email: '', destination: '', groupSize: '' });
      } else {
        toast.error('Erro ao enviar. Por favor, tente novamente.');
      }
    } catch (error) {
      toast.error('Erro ao enviar. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12 fade-in-up">
            <div className="inline-block px-4 py-2 bg-accent/10 border border-accent/30 rounded-full mb-4">
              <p className="text-accent font-bold text-sm">SOLICITE SEU ORÇAMENTO</p>
            </div>
            <h2 className="text-primary mb-4">ORÇAMENTO SEM COMPROMISSO</h2>
            <p className="text-lg text-muted-foreground font-medium">
              Preencha o formulário abaixo e receba uma proposta personalizada em até 24 horas.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6 fade-in-up">
            <div>
              <label htmlFor="name" className="block text-sm font-semibold text-foreground mb-2">
                <User size={16} className="inline mr-2 text-accent" />
                Nome Completo
              </label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Seu nome completo" className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all" />
            </div>

            <div>
              <label htmlFor="phone" className="block text-sm font-semibold text-foreground mb-2">
                <Phone size={16} className="inline mr-2 text-accent" />
                Telefone
              </label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required placeholder="(48) 99190-4829" className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all" />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-foreground mb-2">
                <Mail size={16} className="inline mr-2 text-accent" />
                Email
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="seu@email.com" className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all" />
            </div>

            <div>
              <label htmlFor="destination" className="block text-sm font-semibold text-foreground mb-2">
                <MapPin size={16} className="inline mr-2 text-accent" />
                Local de Destino
              </label>
              <select id="destination" name="destination" value={formData.destination} onChange={handleChange} required className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all bg-white">
                <option value="">Selecione um destino</option>
                <option value="Chile">Chile</option>
                <option value="África do Sul">África do Sul</option>
                <option value="Tanzânia">Tanzânia</option>
                <option value="Zanzibar">Zanzibar</option>
                <option value="Dubai">Dubai</option>
                <option value="Ilhas Maurício">Ilhas Maurício</option>
                <option value="Outro">Outro</option>
              </select>
            </div>

            <div>
              <label htmlFor="groupSize" className="block text-sm font-semibold text-foreground mb-2">
                <Users size={16} className="inline mr-2 text-accent" />
                Quantidade de Pessoas
              </label>
              <input type="number" id="groupSize" name="groupSize" value={formData.groupSize} onChange={handleChange} required min="1" placeholder="Número de pessoas" className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all" />
            </div>

            <button type="submit" disabled={isSubmitting} className="w-full btn-primary py-3 font-bold text-lg rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">
              {isSubmitting ? 'Enviando...' : 'Solicitar Orçamento'}
            </button>
          </form>

          <div className="mt-12 p-6 bg-accent/5 border border-accent/20 rounded-lg text-center">
            <p className="text-muted-foreground">
              Prefere falar por telefone?{' '}
              <a href="https://wa.me/5548991904829" target="_blank" rel="noopener noreferrer" className="font-bold text-accent hover:underline">
                Clique aqui para conversar no WhatsApp
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
